<template>
<div>
    <loader v-if="isLoading" />
    <form class="form form-horizonal" v-if="!isLoading" v-on:submit.prevent data-vv-scope="nationalRegisterStatusForm">
        <div class="form-group">
            <label class="control-label col-md-2">Condition</label>
            <div class="col-md-10" style="padding-left:20px">
                <div class="row form-inline">
                    <label class="control-label">Disturbance<span>Check all that apply; indicate specific areas of disturbance and vandalism on a copy of the site map</span></label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'disturbanceInstanceList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <checkBoxPanel :numColumns="4" :lookupList="disturbanceList" ref='disturbanceCheckboxPanel' :fieldName="'disturbanceTypeId'" :name="qaqcFieldId + 'NRSDisturbanceCB'" />
                <div class="form-group">
                    <label>Percent of property badly disturbed <span>As of this recording date, to nearest 10%</span></label>
                    <div class="form-group form-inline">
                        <input type="number" min="0" step="10" max="100" class="form-control form-inline" v-model="historicalRegisterStatus.disturbancePercent" v-validate="'required|between:0,100'" name="disturbance percentage">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'disturbancePercent'" :hasAppend="false"></qaqcFormFieldSelect>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">NRHP SIGNIFICANCE</label>
            <div class="col-md-10"  style="padding-left:20px">
                <div class="form-inline">
                    <label>Period(s) of significance</label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'significantPeriodInstanceList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <fieldset :disabled="isConditionReport && !qaqcEnabled">
                    <checkBoxPanel :numColumns="4" :lookupList="significantPeriodList" ref='significantPeriodCheckboxPanel' :fieldName="'significantPeriodId'" :name="qaqcFieldId + 'RSSignificantPeriodCB'" ></checkboxPanel>
                </fieldset>
                <div class="form-inline">
                    <label>Theme(s)</label>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'themeInstanceList'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <fieldset :disabled="isConditionReport && !qaqcEnabled">
                    <checkBoxPanel :numColumns="4" :lookupList="themeList" ref='themeCheckboxPanel' :fieldName="'themeId'"  :name="qaqcFieldId + 'NRSThemeCB'" />
                </fieldset>
            </div>
        </div>
        <div class="form-group form-inline">
            <label class="col-md-3 col-md-offset-2">Discuss period of significance</label>
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'periodDescription'" :hasAppend="true"></qaqcFormFieldSelect>
        </div>        
        <div class="form-group">
            <div class="col-md-10 col-md-offset-2">
                <fieldset :disabled="isConditionReport && !qaqcEnabled">  
                    <textarea
                        class="form-control" rows="6" v-model="historicalRegisterStatus.periodDescription"
                        v-validate="{ required: !isConditionReport || qaqcEnabled }"/>
                </fieldset>
            </div>
        </div>
        
        <div v-if="!(qaqcEnabled || formDisabled)" class="form-group">
            <div class="col-md-2">
                <button class="btn btn-primary pull-right" v-on:click="saveNRHP">Save</button>
            </div>
        </div>
        <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'nationalRegisterStatus'" :completeSection="completeSection"></qaqcFormFieldFooter>
    </form>
</div>
</template>

<script>

import loggingService from '../../services/util/loggingService'
//import culturalResourceService from '../../services/culturalResourceService'
// import culturalResourceRecordingService from '../../services/culturalResourceRecordingService'
import disturbanceService from '../../services/siteForm/disturbanceService'
import significantPeriodService from '../../services/siteForm/significantPeriodService'
import themeService from '../../services/siteForm/ThemeService'
import historicalRegisterStatusService from '../../services/siteForm/HistoricalRegisterStatusService'
// import qaqcService from '@/services/qaqcService'

import loader from '../Loader.vue'
import checkBoxPanel from '../CheckBoxPanel.vue'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'

import { tab, tabs } from 'vue-strap'

export default {
    name: 'NationalRegisterStatusForm',
    components: {
        checkBoxPanel,
        tab,
        tabs,
        loader,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter
    },
    props: {
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null },
        isConditionReport: { default: false }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            disturbanceList: disturbanceService.getDisturbanceList(),
            significantPeriodList: significantPeriodService.getSignificantPeriodList(),
            themeList: themeService.getThemeList(),
            eligibilityCriteriaList: [],
            historicalRegisterStatus: {},
            enrolledList: []
        }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no nationalRegisterStatus qa/qc object, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.nationalRegisterStatus) {
                //     this.qaqcProgressDto.qaqcSelections.nationalRegisterStatus = qaqcService.qaqcSelections().nationalRegisterStatus
                // }
                return this.qaqcProgressDto.qaqcSelections.nationalRegisterStatus
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.isLoading = false
            })
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'NationalRegisterStatusForm', message)
        },
        loadDisturbances () {
            this.log('load disturbance')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return disturbanceService.search(this.$http, searchDto).then(result => {
                this.log('disturbance[0]:' + result.data[0])
                this.$refs.disturbanceCheckboxPanel.selectedList = result.data.map(x => {
                    return x.disturbanceTypeId
                })
                return result
            })
        },
        loadSignificantPeriods () {
            this.log('load Sig period')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return significantPeriodService.search(this.$http, searchDto).then(result => {
                this.$refs.significantPeriodCheckboxPanel.selectedList = result.data.map(x => {
                    return x.significantPeriodId
                })
            })
        },
        loadThemes () {
            this.log('load theme')
            var searchDto = {historicalRegisterStatusInstanceId: this.historicalRegisterStatus.historicalRegisterStatusInstanceId}
            return themeService.search(this.$http, searchDto).then(result => {
                this.log('Found themes' + result.data.length)
                this.$refs.themeCheckboxPanel.selectedList = result.data.map(x => {
                    return x.themeId
                })
                return result
            })
        },
        loadData () {
            var crrId = this.crrId
            this.log('Loading Data for crrId: ' + crrId)
            return historicalRegisterStatusService.search(this.$http, {culturalResourceRecordingId: crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found one response')
                    this.historicalRegisterStatus = response.data[0]
                    this.log('enrolled:' + this.historicalRegisterStatus.isEnrolledOnNrhp)
                    // // set disturbanceList
                    // this.$refs.disturbanceCheckboxPanel.selectedList = this.historicalRegisterStatus.disturbanceInstanceList.map(x => {
                    //     return x.disturbanceTypeId
                    // })
                    // // set significantPeriodInstanceList
                    // this.$refs.significantPeriodCheckboxPanel.selectedList = this.historicalRegisterStatus.significantPeriodInstanceList.map(x => {
                    //     return x.significantPeriodId
                    // })
                    // // set the themeInstanceList
                    // this.$refs.themeCheckboxPanel.selectedList = this.historicalRegisterStatus.themeInstanceList.map(x => {
                    //     return x.themeId
                    // })
                    Promise.all([
                        this.loadDisturbances(),
                        this.loadSignificantPeriods(),
                        this.loadThemes()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('creating new instance')
                    return this.createNewInstance()
                }
            })
        },
        loadLookups () {
            // this.disturbanceList = disturbanceService.getDisturbanceList()
            // this.significantPeriodList = significantPeriodService.getSignificantPeriodList()
            // this.themeList = themeService.getThemeList()
        },
        createNewInstance () {
            this.historicalRegisterStatus = {
                isLandmarkMonument: false,
                isEnrolledOnNrhp: false,
                disturbancePercent: '',
                periodDescription: '',
                culturalResourceRecordingId: this.crrId
            }
            return Promise.resolve(1)
        },
        saveNRHP () {
            this.$validator.validateAll('nationalRegisterStatusForm').then(result => {
                if (result) {
                    // set the component checkbox lists
                    var nrhpId = this.historicalRegisterStatus.historicalRegisterStatusInstanceId
                    this.historicalRegisterStatus.disturbanceInstanceList = this.$refs.disturbanceCheckboxPanel.selectedList.map(x => {
                        return {
                            historicalRegisterStatusInstanceId: nrhpId,
                            disturbanceTypeId: x
                        }
                    })
                    this.historicalRegisterStatus.significantPeriodInstanceList = this.$refs.significantPeriodCheckboxPanel.selectedList.map(x => {
                        return {
                            historicalRegisterStatusInstanceId: nrhpId,
                            significantPeriodId: x
                        }
                    })
                    this.historicalRegisterStatus.themeInstanceList = this.$refs.themeCheckboxPanel.selectedList.map(x => {
                        return {
                            historicalRegisterStatusInstanceId: nrhpId,
                            themeId: x
                        }
                    })
                    historicalRegisterStatusService.put(this.$http, this.historicalRegisterStatus).then(response => {
                        this.loadData().then(response2 => {
                            this.log('done saving' + response)
                        })
                    })
                }
            })
        },
        completeSection (sectionName) {
            // check if all selections have been made
            if (Object.values(this.qaqcSelection).includes(0)) {
                alert('Please complete all QA/QC selections in this section.')
                return
            }
            this.saveNRHP()
            this.saveQaqcProgress(sectionName, true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// NationalRegisterStatusForm.vue?52dca301